import { marketingHref } from '@/lib/marketing';

// Hangar has no age gate (owner 2026-10-08): the limit is what its AI will make.
export const HANGAR_DOWNLOAD_PATH = '/download';

/**
 * Learn home entry for Airbotix Hangar, the desktop app where kids build real
 * projects with an AI helper. Shown to every kid (age is passed only for a kid
 * account); a parent pairs the computer before the helper works.
 */
export function HangarDownloadCard({ age }: { age: number | undefined }) {
  if (age === undefined) return null;
  return (
    <a
      href={marketingHref(HANGAR_DOWNLOAD_PATH)}
      target="_blank"
      rel="noreferrer"
      className="pack-card sky relative mt-4 block overflow-hidden"
      data-testid="home-hangar"
    >
      <span className="pack-blob" />
      <div className="relative z-10">
        <div className="text-[11px] font-bold uppercase tracking-[0.14em] opacity-85">Desktop app</div>
        <div className="mt-4 text-[24px] font-bold leading-tight">🛠️ Airbotix Hangar</div>
        <div className="mt-2 text-[14px] opacity-90">
          Build real apps and games on your own computer with an AI helper. Ask a parent to pair the computer first.
        </div>
        <div className="mt-6 inline-block rounded-full bg-canvas-pure/25 backdrop-blur px-4 py-2 text-[12px] font-bold uppercase tracking-[0.10em]">
          Get Hangar →
        </div>
      </div>
    </a>
  );
}
